import { Capacitor } from '@capacitor/core';
import * as Sentry from '@sentry/capacitor';
import * as SentryReact from '@sentry/react';

export const setupSentry = () => {
    Sentry.init(
        {
            dsn: 'https://238b3649efcaa4d4e4d07a994e304604@o4509487923003392.ingest.us.sentry.io/4509487924707328',
            environment: window.ENVIRONMENT_NAME,
            release: window.CLIENT_VERSION,
            dist: Capacitor.getPlatform() === 'web' ? 'web' : 'native',
            enableNative: Capacitor.isNativePlatform(),

            integrations: [Sentry.browserTracingIntegration()],

            tracesSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
            replaysSessionSampleRate: 0.01,

            // Filter out browser extension errors
            beforeSend(event, hint) {
                // Check if error comes from browser extension
                const frames = event.exception?.values?.[0]?.stacktrace?.frames || [];

                // Common extension URL patterns
                const isExtensionError = frames.some((frame) => {
                    const filename = frame.filename || '';
                    return (
                        filename.includes('chrome-extension://') ||
                        filename.includes('moz-extension://') ||
                        filename.includes('safari-extension://') ||
                        filename.includes('webkit-masked-url://')
                    );
                });

                if (isExtensionError) {
                    return null; // Don't send to Sentry
                }

                return event;
            },

            initialScope: {
                tags: {
                    platform: Capacitor.getPlatform(),
                },
            },
        },
        SentryReact.init
    );
};
